import { render, staticRenderFns } from "./RELVeiculosCerca.vue?vue&type=template&id=0dca555a&"
import script from "./RELVeiculosCerca.vue?vue&type=script&lang=js&"
export * from "./RELVeiculosCerca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports